import type { ListeTableFilterData } from '@mairistem/liste';
import React from 'react';

import type { CycleType } from '@/types';

export type CycleContextType = {
  total: number;
  loading: boolean;
  cycles: CycleType[];
  filters: ListeTableFilterData[];
  search: string;
  sorts: Record<string, 'asc' | 'desc'>;
  setCycles: React.Dispatch<React.SetStateAction<CycleType[]>>;
  setFilters: React.Dispatch<React.SetStateAction<ListeTableFilterData[]>>;
  setSearch: React.Dispatch<React.SetStateAction<string>>;
  setSorts: React.Dispatch<React.SetStateAction<Record<string, string>>>;
  setPage: React.Dispatch<React.SetStateAction<number>>;
  setTotal: React.Dispatch<React.SetStateAction<number>>;
  getCycles: () => void;
};

const CycleContext = React.createContext<CycleContextType>({
  total: 0,
  loading: false,
  cycles: [],
  filters: [],
  search: '',
  sorts: {},
  setCycles: () => {},
  setFilters: () => {},
  setSearch: () => {},
  setSorts: () => {},
  setPage: () => {},
  setTotal: () => {},
  getCycles: () => {},
});

export default CycleContext;
